const passlyDomains = [
    'localhost:3000',
    'localhost:44300',
    'my.authanvil.com',
    'qa.authanvil.com',
    'dev.authanvil.com',
    'my.authanvil.eu',
    'staging.authanvil.com',
    'support.authanvil.com',
    'my.passly.com',
    'qa.passly.com',
    'dev.passly.com',
    'my.passly.eu',
    'staging.passly.com',
    'support.passly.com'
];

// We need to check if script didn't changed and user emit event from our domain
// to our domain and third-side script can't listen this event
export function getOriginUrl() {
    const currentDomain = window.location.host;
    let rootDomain;

    if (currentDomain === passlyDomains[0] || currentDomain === passlyDomains[1]) {
        rootDomain = currentDomain;
    } else {
        const domainParsed = currentDomain.split('.').reverse();
        rootDomain = `${domainParsed[2]}.${domainParsed[1]}.${domainParsed[0]}`;
    }

    if (passlyDomains.includes(rootDomain)) {
        return window.location.origin;
    }
    return '';
}
